export default __webpack_public_path__ + "static/media/trr-drink-coffeecocktail-carajillo.96c5cfbd.png";